import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import axios from 'axios';
import qs from 'qs';
import * as constants from '../util/constants';
import helpers from '../util/helpers';

const OffersSkeleton = () => {
  return (
    <Fragment>
      {
        Array.from(Array(12).keys()).map((i) => {
          return (
            <div key={i} className="col-span-1">
              <div className="offer-item skeleton">
                <div className="offer-item-image-wrapper skeleton-shine" />
                <div className="offer-item-site-title skeleton-shine" />
                <div className="offer-item-title skeleton-shine" />
                <div className="offer-item-link skeleton-shine" />
              </div>
            </div>
          );
        })
      }
    </Fragment>
  );
};

class AppGlobalOffers extends Component {
  constructor(props) {
    super(props);

    // Initial state
    this.initialState = {
      loading: true,
      offersCount: 0,
      allOffers: [],
      loadMoreLoading: false,
      loadedAll: false,
    };

    // Assign first state
    this.state = Object.assign({}, this.initialState);

    this.location = '';
    this.type = '';

    const location = helpers.getParameterByName('location');
    if (location != null && location.length) {
      this.location = location;
    }

    const type = helpers.getParameterByName('type');
    if (type != null && type.length) {
      this.type = type;
    }

    this.loadOffers = this.loadOffers.bind(this);
    this.loadMoreOffers = this.loadMoreOffers.bind(this);

    // Cancel token source
    this.source = axios.CancelToken.source();
  }

  componentDidMount() {
    // Load results on first page load
    this.loadOffers();

    $(document).on(constants.EVENT_OFFERS_LOCATION_FILTER_CHANGED, (e, location) => {
      if (this.location !== location) {
        this.location = location;
        this.loadOffers();
      }
    });

    $(document).on(constants.EVENT_OFFERS_TYPE_FILTER_CHANGED, (e, type) => {
      if (this.type !== type) {
        this.type = type;
        this.loadOffers();
      }
    });
  }

  loadOffers() {
    // Stop loading old results
    if (this.state.loading) {
      this.source.cancel('Cancelled retrieving data');
      this.source = axios.CancelToken.source(); // Generate new source token
    }

    // Reset state
    this.setState(this.initialState);

    // Params
    const data = {
      'action': constants.ACTION_GET_GLOBAL_OFFERS,
      'location': this.location,
      'type': this.type,
      'featured_offer': this.props.featuredOffer,
      'offset': 0,
    };

    // Send request
    axios.post(window.Ode['ajaxUrl'], qs.stringify(data), {
      cancelToken: this.source.token,
    }).then((axiosResponse) => {
      if (200 === axiosResponse.status) {
        const response = axiosResponse.data;

        if (response.success) {
          const offersCount = response.data['offers_count'];
          const offers = response.data['offers'];

          if (offersCount > 0) {
            this.setState({
              loading: false,
              offersCount,
              allOffers: [...offers],
              loadMoreLoading: false,
              loadedAll: parseInt(offersCount) === offers.length,
            });
          } else {
            this.setState({
              loading: false,
              offersCount: 0,
              allOffers: [],
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        } else {
          this.setState({
            loading: false,
            offersCount: 0,
            allOffers: [],
            loadMoreLoading: false,
            loadedAll: true,
          });
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  loadMoreOffers() {
    const {
      allOffers,
      loadedAll,
    } = this.state;

    if (!loadedAll) {
      this.setState({
        loading: false,
        loadMoreLoading: true,
      });

      // Params
      const data = {
        'action': constants.ACTION_GET_GLOBAL_OFFERS,
        'location': this.location,
        'type': this.type,
        'featured_offer': this.props.featuredOffer,
        'offset': allOffers.length,
      };

      // Send request
      axios.post(window.Ode['ajaxUrl'], qs.stringify(data), {
        cancelToken: this.source.token,
      }).then((axiosResponse) => {
        if (200 === axiosResponse.status) {
          const response = axiosResponse.data;

          if (response.success) {
            const offersCount = response.data['offers_count'];
            const offers = [
              ...allOffers,
              ...response.data['offers'],
            ];

            if (offersCount > 0) {
              this.setState({
                loading: false,
                allOffers: [...offers],
                loadMoreLoading: false,
                loadedAll: parseInt(offersCount) === offers.length,
              });
            } else {
              this.setState({
                loading: false,
                loadMoreLoading: false,
                loadedAll: true,
              });
            }
          } else {
            this.setState({
              loading: false,
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        }
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  render() {
    const {
      loading,
      allOffers,
      loadMoreLoading,
      loadedAll,
    } = this.state;

    return (
      <div className="container">
        <div className="offer-items-grid grid grid-cols-1 xl:grid-cols-3 gap-x-5 gap-y-10 xl:gap-y-8">
          {
            !loading && allOffers.length > 0 && (
              <Fragment>
                {
                  allOffers.map((offer, i) => {
                    return (
                      <div key={i} className="col-span-1">
                        <div className="offer-item">
                          <a href={offer['link']} className="offer-item-image-wrapper">
                            {
                              offer['image'].length > 0 && (
                                <img src={offer['image']}
                                     className="offer-item-image"
                                     loading="lazy"
                                     decoding="async"
                                     alt=""
                                />
                              )
                            }
                          </a>
                          {
                            offer['site_title'].length > 0 && (
                              <div className="offer-item-site-title">
                                {offer['site_title']}
                              </div>
                            )
                          }
                          {
                            offer['title'].length > 0 && (
                              <div className="offer-item-title">
                                <a href={offer['link']}>
                                  {offer['title']}
                                </a>
                              </div>
                            )
                          }
                          {
                            offer['link'].length > 0 && (
                              <a href={offer['link']} className="btn">
                                View Details
                              </a>
                            )
                          }
                        </div>
                      </div>
                    );
                  })
                }
              </Fragment>
            )
          }
          {
            (loading || loadMoreLoading) && (
              <OffersSkeleton />
            )
          }
        </div>
        <div className="load-more-button-container">
          <button className="btn btn-outline-black btn-load-more" disabled={loading || loadMoreLoading || loadedAll} onClick={this.loadMoreOffers}>
            {!loadedAll ? 'Load More' : 'That\'s All'}
          </button>
        </div>
      </div>
    );
  }
}

AppGlobalOffers.propTypes = {
  featuredOffer: PropTypes.string,
};

AppGlobalOffers.defaultProps = {
  featuredOffer: '',
};

export default {
  init() {
    // JavaScript to be fired on init
  },
  finalize() {
    // Render results
    const globalOffersWrapper = $('#global-offers-wrapper');
    if (globalOffersWrapper.length) {
      const globalOffersProps = {...globalOffersWrapper[0].dataset};

      ReactDOM.render(<AppGlobalOffers {...globalOffersProps} />, globalOffersWrapper[0]);
    }

    const handleFeaturedOfferSectionDisplay = function () {
      const globalOffersFeaturedOffer = $('.global-offers-featured-offer');
      let hideSection = false;

      const location = helpers.getParameterByName('location');
      if (location != null && location.length) {
        hideSection = true;
      }

      const type = helpers.getParameterByName('type');
      if (type != null && type.length) {
        hideSection = true;
      }

      if (globalOffersFeaturedOffer.length) {
        if (hideSection) {
          globalOffersFeaturedOffer.hide();
        } else {
          globalOffersFeaturedOffer.show();
        }
      }
    };

    handleFeaturedOfferSectionDisplay();

    const offerLocationsFilter = $('#offer-locations-filter');
    if (offerLocationsFilter.length) {
      offerLocationsFilter.on('select2:select', function () {
        const _this = $(this);
        const selectedVal = _this.val();
        const params = helpers.getParameters();

        if (selectedVal !== '') {
          params['location'] = selectedVal;
        } else {
          delete params['location'];
        }

        // Push params to url
        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

        handleFeaturedOfferSectionDisplay();

        $(document).trigger(constants.EVENT_OFFERS_LOCATION_FILTER_CHANGED, [selectedVal]);
      });
    }

    const offerTypesFilter = $('#offer-types-filter');
    if (offerTypesFilter.length) {
      offerTypesFilter.on('select2:select', function () {
        const _this = $(this);
        const selectedVal = _this.val();
        const params = helpers.getParameters();

        if (selectedVal !== '') {
          params['type'] = selectedVal;
        } else {
          delete params['type'];
        }

        // Push params to url
        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

        handleFeaturedOfferSectionDisplay();

        $(document).trigger(constants.EVENT_OFFERS_TYPE_FILTER_CHANGED, [selectedVal]);
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalOffersPage.js